import React, { Component } from 'react';

class InvalidRouteView extends Component {
    state = {  }
    render() { 
        return (  
            <div>
                <div className="full_page_format">
                    <br />

                    <h1>Invalid Request</h1>

                    <br />
                    <br />
                    <br />

                </div>
            </div>
        );
    }
}
 
export default InvalidRouteView;